import { render } from "./TicketPago.vue?vue&type=template&id=341a57d1&scoped=true"
import script from "./TicketPago.vue?vue&type=script&lang=js"
export * from "./TicketPago.vue?vue&type=script&lang=js"

import "./TicketPago.vue?vue&type=style&index=0&id=341a57d1&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341a57d1"]])

export default __exports__